export default "__VITE_ASSET__DpNrlUtA__";